import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import requester from '@/lib/axios';
import Exam, { ExamDTO, ExamTypeEnum } from '@/models/Exam';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

export interface ExamFilter extends BaseFilters {
  coursePathId?: number;
  assessmentItemId?: number;
  authorId?: number;
  type?: ExamTypeEnum;
  status?: VersioningStatusEnum[];
}

const baseUrl = 'exams';

export const listExams = async (params: ExamFilter = {}) => {
  const { data } = await requester().get<JsonApiResponse<Exam>>(`${baseUrl}/`, {
    params,
  });
  return data;
};

export const getExam = async (examId: number) => {
  const { data } = await requester().get<Exam>(`${baseUrl}/${examId}/`);
  return data;
};

export const createExam = async (body: Partial<ExamDTO>) => {
  const { data } = await requester().post<Exam>(`${baseUrl}/`, body);
  return data;
};

export const updateExam = async (examId: number, body: Partial<ExamDTO>) => {
  const { data } = await requester().patch<Exam>(`${baseUrl}/${examId}/`, body);
  return data;
};

export const deleteExam = async (examId: number) => {
  await requester().delete<void>(`${baseUrl}/${examId}/`);
};

export const updateExamOrder = async (
  coursePathSlug: string,
  body: Array<{ id: number }>,
) => {
  await requester().patch<void>(
    `courses/${coursePathSlug}/${baseUrl}/order/`,
    body,
  );
};
